import React from "react";
import style from "./Details.module.scss";
import Avatar from "../../../../components/Avatar/Avatar";
import Financials from "./Financials";
import BusinessInformation from "./BusinessInformation";
import PersonalInformation from "./PersonalInformation";
import BusinessProfile from "./BusinessProfile";
import Equipments from "./Equipments";
import Documents from "./Documents";
import useMerchantStore from "../../../../stores/merchant";
import useCommonStore from "../../../../stores/common";

function Details() {
  const activeApp = useMerchantStore((state) => state.activeApp);
  const expandDetails = useCommonStore((state) => state.expandDetails);

  return (
    <div className={style.details_tab}>
      <div className={style.rep}>
        <Avatar size="medium" name={activeApp?.user?.name?.charAt(0)} />
        <div className={style.rep_details}>
          <p className={style.rep_label}>Representative</p>
          <p className={style.rep_name}>
            {activeApp?.user?.name}
          </p>
        </div>
      </div>

      <div className={style.accordion}>
        <Financials />
        <BusinessInformation />
        <PersonalInformation appData={activeApp} expandAppDetails={expandDetails} />
        <BusinessProfile appData={activeApp} expandAppDetails={expandDetails} />
        <Equipments appData={activeApp} expandAppDetails={expandDetails} />
        <Documents appData={activeApp} expandAppDetails={expandDetails}  />
      </div>
    </div>
  );
}

export default Details;
